import { typedRpc } from "@/integrations/supabase/typedRpcClient";

export const hireMeRequest = async (
  profileId: string,
  profileUsername: string,
  userId: string | null,
  requesterName: string,
  requesterEmail: string,
  projectDescription: string,
  budget: number,
  currency: string,
  deadline: string
) => {
  try {
    const { data, error } = await typedRpc.call("handle_hire_me_request", {
      p_profile_id: profileId,
      p_profile_username: profileUsername,
      p_requester_id: userId || null,
      p_requester_email: requesterEmail,
      p_project_description: projectDescription,
      p_budget: budget,
      p_currency: currency,
      p_deadline: deadline,
      p_requester_name: requesterName,
      p_status: "pending",
    });
    if (error) {
      console.error("Error requesting hire me:", error);
      return false;
    }
    return true;
  } catch (error) {
    console.error("Error requesting hire me:", error);
  }
};
